/* TCFJ bag drawer, bag updates, drop a hint, predictive search and signup popup. No apps. */
(function () {
  if (window.__tcfjShop) return; window.__tcfjShop = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var lastFocus;

  /* ---------- Bag drawer ---------- */
  function drawer() { return $('[data-tcfj-drawer]'); }
  function drawerSection() { var b = $('[data-tcfj-drawer] [data-tcfj-cart-root]'); return b && b.getAttribute('data-section'); }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false; document.body.classList.add('tcfj-lock');
    requestAnimationFrame(function () { d.classList.add('is-open'); var p = $('.tcfj-drawer2__panel', d); p && p.focus(); });
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.classList.remove('is-open'); document.body.classList.remove('tcfj-lock');
    setTimeout(function () { d.hidden = true; }, 250);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function refreshSections(ids) {
    ids = ids.filter(Boolean);
    if (!ids.length) return Promise.resolve();
    return fetch(root + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (json) {
      ids.forEach(function (id) {
        var html = json[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = document.getElementById('shopify-section-' + id);
        if (!wrap) return;
        if (wrap.querySelector('[data-tcfj-drawer]')) {
          // keep the drawer open: swap only its inner panel contents
          var oldP = wrap.querySelector('.tcfj-drawer2__panel'), newP = doc.querySelector('.tcfj-drawer2__panel');
          if (oldP && newP) oldP.innerHTML = newP.innerHTML;
        } else {
          var n = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
          if (n) wrap.innerHTML = n.innerHTML;
        }
      });
      window.TCFJFav && window.TCFJFav.paint();
    });
  }
  function refreshAll() {
    var page = $('.tcfj-cartpage [data-tcfj-cart-root]');
    return refreshSections([drawerSection(), page && page.getAttribute('data-section')])
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="' + root + 'cart"], a[href="/cart"]');
    if (a && !e.target.closest('[data-tcfj-drawer]') && !e.target.closest('.tcfj-cartpage') && location.pathname.indexOf('/cart') !== 0) {
      if (openDrawer()) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-tcfj-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var q = e.target.closest('[data-tcfj-cart-root] [data-qty]');
    if (q) {
      e.preventDefault();
      var line = q.closest('[data-line]'); line.classList.add('is-busy');
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.getAttribute('data-line'), quantity: parseInt(q.getAttribute('data-qty'), 10) }) })
        .then(function (r) { return r.json(); }).then(refreshAll)
        .catch(function () { line.classList.remove('is-busy'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer(); closeSearch(); closeHint(); closePop();
  });
  // after any add to bag elsewhere on the site
  document.documentElement.addEventListener('cart:refresh', function () {
    refreshAll().then(function () { if (location.pathname.indexOf('/cart') !== 0) openDrawer(); });
  });

  /* ---------- Drop a hint (opens the shopper's own email) ---------- */
  function closeHint() { var m = $('[data-tcfj-hint]'); if (m && !m.hidden) { m.hidden = true; document.body.classList.remove('tcfj-lock'); } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tcfj-hint-open]')) { var m = $('[data-tcfj-hint]'); if (m) { m.hidden = false; document.body.classList.add('tcfj-lock'); var f = $('input', m); f && f.focus(); } }
    if (e.target.closest('[data-tcfj-hint-close]')) closeHint();
    var c = e.target.closest('[data-tcfj-hint-copy]');
    if (c) {
      var f = c.closest('form'), link = f.getAttribute('data-link'), st = $('[data-tcfj-hint-status]', f);
      (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(function () { st.textContent = 'Link copied. Paste it anywhere.'; }, function () { st.textContent = link; });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-tcfj-hint-form]'); if (!f) return;
    e.preventDefault();
    var from = f.from.value.trim(), to = f.to.value.trim(), email = f.email.value.trim();
    var subj = 'A little hint from ' + (from || 'someone who loves you');
    var body = (to ? 'Hi ' + to + ',\n\n' : 'Hi,\n\n') + 'I have my eye on something from ' + f.getAttribute('data-shop') + ': ' + f.getAttribute('data-items') + '.\n\nIt is all ready in a bag for you here:\n' + f.getAttribute('data-link') + '\n\n' + (from ? 'Love,\n' + from : '');
    location.href = 'mailto:' + encodeURIComponent(email) + '?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body);
    $('[data-tcfj-hint-status]', f).textContent = 'Your email app should open with the hint ready to send.';
  });

  /* ---------- Predictive search ---------- */
  var ps, t;
  function closeSearch() { ps = $('[data-tcfj-psearch]'); if (ps && !ps.hidden) { ps.hidden = true; document.body.classList.remove('tcfj-lock'); } }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="' + root + 'search"], a[href="/search"]');
    ps = $('[data-tcfj-psearch]');
    if (a && ps && !e.target.closest('.tcfj-searchpage') && !e.target.closest('.tcfj-nf')) {
      e.preventDefault(); ps.hidden = false; document.body.classList.add('tcfj-lock');
      setTimeout(function () { $('[data-tcfj-psearch-input]', ps).focus(); }, 30);
      return;
    }
    if (e.target.closest('[data-tcfj-psearch-close]')) closeSearch();
  });
  function money(cents) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); } catch (e) { return '$' + Math.round(cents / 100); } }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-tcfj-psearch-input]'); if (!inp) return;
    var res = $('[data-tcfj-psearch-res]'), side = $('.tcfj-psearch__side', res);
    clearTimeout(t);
    var q = inp.value.trim();
    if (q.length < 2) { $$('.tcfj-psearch__live', res).forEach(function (n) { n.remove(); }); return; }
    t = setTimeout(function () {
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); }).then(function (j) {
          var R = (j.resources && j.resources.results) || {};
          $$('.tcfj-psearch__live', res).forEach(function (n) { n.remove(); });
          var sug = document.createElement('div'); sug.className = 'tcfj-psearch__live tcfj-psearch__sug';
          var h = '<span class="tcfj-drawer2__k">Suggestions</span><ul>';
          (R.queries || []).forEach(function (s) { h += '<li><a href="' + s.url + '">' + esc(s.text) + '</a></li>'; });
          (R.pages || []).forEach(function (p) { h += '<li><a href="' + p.url + '">' + esc(p.title) + '</a></li>'; });
          h += '</ul>'; sug.innerHTML = h; side.insertBefore(sug, side.firstChild);
          var prod = document.createElement('div'); prod.className = 'tcfj-psearch__live tcfj-psearch__prods';
          var ph = '<div class="tcfj-psearch__ph"><span class="tcfj-drawer2__k">Products</span><a class="tcfj-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results</a></div><div class="tcfj-psearch__grid">';
          (R.products || []).forEach(function (p) {
            var price = p.price_min && p.price_max && p.price_min !== p.price_max ? money(+p.price_min * 100) + ' – ' + money(+p.price_max * 100) : money(+(p.price || p.price_min) * 100);
            ph += '<a class="tcfj-psearch__card" href="' + p.url + '"><span class="tcfj-card__img">' + (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '') + '</span><span class="tcfj-card__title">' + esc(p.title) + '</span><span class="tcfj-card__price">' + price + '</span></a>';
          });
          if (!(R.products || []).length) ph += '<p class="tcfj-sub">No pieces match yet. Press Enter to search everything.</p>';
          ph += '</div>'; prod.innerHTML = ph; res.appendChild(prod);
        }).catch(function () {});
    }, 220);
  });

  /* ---------- Signup popup ---------- */
  function closePop() {
    var p = $('[data-tcfj-pop]'); if (!p || p.hidden) return;
    p.hidden = true; document.body.classList.remove('tcfj-lock');
    try { localStorage.setItem('tcfj-pop-until', Date.now() + (+p.getAttribute('data-days') || 14) * 864e5); } catch (e) {}
  }
  function initPop() {
    var p = $('[data-tcfj-pop]'); if (!p) return;
    var anyPosted = /customer_posted=true/.test(location.search);
    var posted = anyPosted && location.hash.indexOf('tcfj-pop-form') > -1;
    if (posted || document.querySelector('#tcfj-pop-form .tcfj-gc__err')) { p.hidden = false; return; }
    if (anyPosted) { try { localStorage.setItem('tcfj-pop-joined', '1'); } catch (e) {} return; }
    try { if (+localStorage.getItem('tcfj-pop-until') > Date.now() || localStorage.getItem('tcfj-pop-joined')) return; } catch (e) {}
    if (document.documentElement.getAttribute('data-tcfj-customer') === '1') return;
    if (/\/(cart|checkout|account|challenge)/.test(location.pathname)) return;
    setTimeout(function () {
      if ($('[data-tcfj-fav-modal].is-open') || $('[data-tcfj-drawer].is-open')) return;
      p.hidden = false; document.body.classList.add('tcfj-lock');
      var i = $('input[type=email]', p); i && i.focus({ preventScroll: true });
    }, (+p.getAttribute('data-delay') || 8) * 1000);
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-tcfj-pop-close]')) closePop(); });
  document.addEventListener('submit', function (e) { if (e.target.closest('#tcfj-pop-form')) { try { localStorage.setItem('tcfj-pop-joined', '1'); } catch (x) {} } });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPop); else initPop();
})();
